import { EnvironmentProviders } from '@angular/core';
import { provideTranslocoMissingHandler } from '@jsverse/transloco';
import { PostHogTranslationMissingHandler } from './posthog-translation-missing-handler';

// Opt-in per app, and must follow provideRmaTranslation(): the last provider of the token wins over Transloco's default.
export function provideRmaTranslationMissingReporting(): EnvironmentProviders {
  return provideTranslocoMissingHandler(PostHogTranslationMissingHandler);
}
